import type { TTerm } from '@/types'
import { LOCALES } from '@/common'
import { SOURCES, TAGS, TYPES } from '@/data/raw'

export default {
  id: `websockets`,

  name: {
    [LOCALES.EN_US]: `WebSockets`,
  },

  label: {
    [LOCALES.EN_US]: ``,
  },

  definition: {
    [LOCALES.EN_US]: ``,
  },

  type: [TYPES.protocol, TYPES.standard],

  tags: [],
} as const satisfies TTerm
